module.exports = __webpack_public_path__ + "HSA_Name_Change.pdf";